export default {"src":"/_next/static/media/protectionData.78013abb.svg","height":480,"width":480,"blurWidth":0,"blurHeight":0};